/* "Nirvik Ready for course authors" (/guides/authors): its own chapters around the shared authoring ones. */
import role from './00-role.md?raw';
import aiAssist from './01-ai-assist.md?raw';
import runEvent from './02-run-an-event.md?raw';
import publish from './03-publish.md?raw';
import checklists from './04-checklists.md?raw';
import { sharedChapters } from '../chapters';
import type { Guide } from '../types';

const s = sharedChapters('authors');

export const authorsGuide: Guide = {
  slug: 'authors',
  title: 'Nirvik Ready for course authors',
  subtitle:
    'How to build courses, quizzes and question banks, draft with AI, run live events and keep everything up to date.',
  audiences: ['authors'],
  pdf: '/guides/authors/nirvik-ready-guide.pdf',
  reviewed: '2026-10-25',
  chapters: [
    {
      slug: 'role',
      title: 'Your role as an author',
      summary: 'Where you work, drafts and who sees what',
      markdown: role,
    },
    s['make-it-yours'],
    s['build-a-course'],
    {
      slug: 'ai-assist',
      title: 'Draft with AI',
      summary: 'Outlines, lessons and questions to review and edit',
      markdown: aiAssist,
    },
    s.assessments,
    s.events,
    {
      slug: 'run-an-event',
      title: 'Run a live event',
      summary: 'Before, on the day and after',
      markdown: runEvent,
    },
    {
      slug: 'publish',
      title: 'Publish and update',
      summary: 'Versions, improvements and archiving',
      markdown: publish,
    },
    s['spread-the-word'],
    {
      slug: 'checklists',
      title: 'Author checklists',
      summary: 'Before you publish a course, a quiz or an event',
      markdown: checklists,
    },
  ],
};
